<div class="log-cinematic-end-to-end-knot">
    <div
        LogFieldTitle
        [withMarginTop]="false"
        [ngClass]="topHeaderColor ? 'log-cinematic-end-to-end-knot__header--' + topHeaderColor : 'log-cinematic-end-to-end-knot__header'"
    >
        {{ headerText }}
    </div>
    <cds-icon
        shape="{{ iconShape }}"
        size="35"
        status="{{ iconStatus }}"
        badge="{{ iconBadge }}"
    ></cds-icon>
</div>
